import { ReactComponent as SvgChevronRight } from '@img/icons/chevron-right.svg';
import React from 'react';
import S from './NextButton.styles';
const NextButton = ({ themeOption, title = 'Next', ...otherProps }) => {
    return (React.createElement(S.Button, { type: "button", icon: SvgChevronRight, themeOption: themeOption, title: title, ...otherProps }));
};
export default NextButton;
